import config from '@/config'

export default {
	id: 'SIMPLE_PAYWALL_12W_59_99_12W_29_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_12w_59_99_12w_29_99_usd',
			EUR: 'simple_premium_12w_59_99_12w_29_99_eur',
			GBP: 'simple_premium_12w_59_99_12w_29_99_gbp',
			AUD: 'simple_premium_12w_99_99_12w_43_99_aud',
			CAD: 'simple_premium_12w_99_99_12w_43_99_cad',
			DKK: 'simple_premium_12w_459_12w_229_dkk',
			SEK: 'simple_premium_12w_699_12w_349_sek',
			NOK: 'simple_premium_12w_699_12w_349_nok',
			BRL: 'simple_premium_12w_179_12w_69_brl',
			MXN: 'simple_premium_12w_999_12w_499_mxn',
			TRY: 'simple_premium_12w_1999_12w_999_try',
			ARS: 'simple_premium_12w_79990_12w_39990_ars',
			COP: 'simple_premium_12w_239990_12w_119990_cop',
			CLP: 'simple_premium_12w_57990_12w_29990_clp',
		},
		primer: 'prd_2mwQhN5AiSNE',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 12,
		intro_period_type: 'week',
		next_period_value: 12,
		next_period_type: 'week',
	},
	trial: {
		days: 84,
		priceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			AUD: 43.99,
			CAD: 43.99,
			DKK: 229,
			SEK: 349,
			NOK: 349,
			BRL: 69,
			MXN: 499,
			TRY: 999,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
		originalPriceMap: {
			USD: 59.99,
			EUR: 59.99,
			GBP: 59.99,
			AUD: 99.99,
			CAD: 99.99,
			DKK: 459,
			SEK: 699,
			NOK: 699,
			BRL: 179,
			MXN: 999,
			TRY: 1999,
			ARS: 79990,
			COP: 239990,
			CLP: 57990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 59.99,
			EUR: 59.99,
			GBP: 59.99,
			AUD: 99.99,
			CAD: 99.99,
			DKK: 459,
			SEK: 699,
			NOK: 699,
			BRL: 179,
			MXN: 999,
			TRY: 1999,
			ARS: 79990,
			COP: 239990,
			CLP: 57990,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.90_days.into_period_text'), // 'first quarter'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.90_days.sub_period_text'), // 'quarterly'
		billingSubtitlePeriodText: $tc('common.duration.week.first', 12), // 'first 12 weeks'
		footerPeriodText: $tc('common.duration.week.dashed.capitalized', 12), // '12-Week'
		footerIntervalText: $tc('common.duration.week.dashed.capitalized', 12), // '12-Week'
	}),
}
